import { styled } from "@linaria/react"
import { observer } from "mobx-react-lite"


import { DomElementScreenshotModel } from "@/components/Chat/DomElementScreenshotModel.ts"
import { Spinner } from "@/components/Spinner/Spinner.tsx"
import { Tooltip } from "@/components/Tooltip/Tooltip.tsx"
import { useModel } from "@/hooks/useModel.ts"
import { useQueries } from "@/hooks/useRootContext.ts"
import { pre } from "@/styles/textStyles.ts"

import type { AiAgentTaskDomElement } from "@/lib/client/generated/TypeDefinitions.ts"

export const DomElementScreenshot = observer((props: { taskId: string, element: AiAgentTaskDomElement }) => {
  const queries = useQueries()
  const model = useModel(() => new DomElementScreenshotModel(queries, props.taskId, props.element), [props.taskId, props.element])

  const imageState = model.imageState.get()
  const screenshotBlobId = props.element.screenshotBlobId

  return imageState.objectUrl
    ? <Screenshot src={imageState.objectUrl} alt="Element screenshot" loading="lazy" />
    : (screenshotBlobId && imageState.loading
      ? <Spinner />
      : <Path>{props.element.path}</Path>)
})

export const DomElementScreenshotTooltip = styled(Tooltip)`
  display: flex;

  color: var(--text-color);
  background: var(--background-color);

  padding: 0;
`

const Path = styled.pre`
  ${pre};

  max-width: 50vw;
`

const Screenshot = styled.img`
  display: block;
  max-width: 50vw;
  max-height: 50vh;
`